export type EventInfoTextSettings = {
	displayOrder: {
		label: string;
		placeholder: string;
	};
	eventType: {
		label: string;
	};
	isFeatured: {
		label: string;
		helperText: string;
	};
	eventTags: {
		locationLabel: string;
		locationPlaceholder: string;
		projectDateTextLabel: string;
		projectDateTextPlaceholder: string;
		tagsLabel: string;
		tagsPlaceholder: string;
		maxTagCount: number;
	};
	appliableSettings: {
		projectDateLabel: string;
		applicationStatusLabel: string;
		applicationStatusHelperText: string;
	};
	notAppliableSettings: {
		categoryTagTrLabel: string;
		categoryTagEnLabel: string;
		categoryTagTrPlaceholder: string;
		categoryTagEnPlaceholder: string;
		customButtonLabel: string;
		customButtonHelperText: string;
	};
};

export const EventInfoTextConstants: EventInfoTextSettings = {
	displayOrder: {
		label: "Sıra Numarası",
		placeholder: "0"
	},
	eventType: {
		label: "Proje Tipi",
	},
	isFeatured: {
		label: "Öne Çıkan",
		helperText: "Öne çıkan projeler sıralamada öncelik alınır."
	},
	eventTags: {
		locationLabel: "Lokasyon Etiketi",
		locationPlaceholder: "İstanbul",
		projectDateTextLabel: "Proje Tarihi Etiketi",
		projectDateTextPlaceholder: "03.06.2026",
		tagsLabel: "Etiketler",
		tagsPlaceholder: "Lütfen seçiniz",
		maxTagCount: 3
	},
	appliableSettings: {
		projectDateLabel: "Proje Tarihi",
		applicationStatusLabel: "Başvuru Durumu",
		applicationStatusHelperText: "Proje Başvuruya açık mı?"
	},
	notAppliableSettings: {
		categoryTagTrLabel: "Kategori Etiketi",
		categoryTagEnLabel: "Category Tag",
		categoryTagTrPlaceholder: "Gönüllülük",
		categoryTagEnPlaceholder: "Volunteering",
		customButtonLabel: "Özel Buton",
		customButtonHelperText: "Başvurulamayan projeler tercihe bağlı olarak yönlendirmeler yapabilirler"
	}
};